// Front-end only — no back-end counterpart.

export type NotificationToastSeverity = 'info' | 'warning' | 'success' | 'danger'

export const NotificationToastSeverity = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  DANGER: 'danger'
} satisfies Record<string, NotificationToastSeverity>

export const NotificationToastSeverityValues: readonly NotificationToastSeverity[] =
  Object.values(NotificationToastSeverity)
